<template>
  <!-- 劳务人员工地统计 -->
  <div class="laborers-site">
    <div class="title">
      <div class="left">劳务人员打卡统计</div>
      <div class="right">
        TOP5
      </div>
    </div>
    <simple-data-count v-if="!!laborersCount" :count="laborersCount" name="劳务人员总数" :length="6">
      <span class="color-block" :style="{borderColor: colorList[0]}">打卡正常</span>
      <span class="color-block" :style="{borderColor: colorList[1]}">打卡异常</span>
    </simple-data-count>
    <simple-rank :color-list="colorList" :data-list="workRankList"/>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import SimpleRank from "@/components/h5/board/SimpleRank3.vue";
import SimpleDataCount from "@/components/h5/board/SimpleDataCount.vue";
import commonApi from "@/api/commonApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EmployeeCollection",
  components: {
    SimpleRank, SimpleDataCount
  },
  data() {
    return {
      laborersCount: 0,
      workRankList: [],
      colorList : ["#38d7ff","#9e66ff"],
    };
  },
  created() {
    // 从缓存中获取菜单
    commonApi.contractWorkerAttendanceList({limit: 5}).then(res => {
      let arr = [];
      if (res && res.length) {
        // statisticCount 是打卡正常  statisticCount2是打卡异常 statisticCount3是总数
        let count = 0;
        for (let i = 0; i < res.length; i++) {
          arr.push({itemName: res[i].statisticName, listCount: [res[i].statisticCount, res[i].statisticCount2], allCount: res[i].statisticCount3});
          count += res[i].statisticCount3;
        }
        this.laborersCount = count;
        this.workRankList = arr;
      }
    })
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../components/h5/board/common";
.laborers-site{
  height: 100%;
  overflow: hidden;
}
.color-block{
  border-left-style: solid;
  border-left-width: 8px;
  margin-left: 10px;
  padding-left: 5px;
}
</style>